// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {execute} from "fg-frontend/src/partialUpdate/partialUpdate";

export default class Attachment extends WebComponent {
	didMount() {
		const {
		} = this.props;

		this.label = this.element.querySelector("label");
		this.input = this.element.querySelector("input");

		this.label.addEventListener('click', () => {
			this.input.click();
		});

		this.input.addEventListener('change', () => {
			const storeAttachment = document.querySelector("#storeAttachment");
			if(storeAttachment) {
				storeAttachment.click();
			}
			const form = document.querySelector("#newForm");
			setTimeout(() => {
				const alert = document.querySelector(".alert");
				if(alert) {
					alert.scrollIntoView({behavior: 'smooth'});
				}
				execute({
					url: form.action,
					target: ['attachmentsPreviewContainer'],
				});
			}, 1500);
		});

	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Attachment.js